const BRAND_BASE = "https://wsafeai.github.io/wsafeai-procore-prototype/brand/products";

const SUITE_LINKS = [
  { name: "WSafe AI", slug: "wsafe-ai", href: "https://wsafe.ai" },
  { name: "InductIQ", slug: "inductiq", href: "https://inductiq.ai" },
  { name: "WorkSafeStory", slug: "worksafestory", href: "https://worksafestory.com" },
  { name: "HazardLoop", slug: "hazardloop", href: "https://hazardloop.com" },
  { name: "EnviSafe", slug: "envisafe", href: "https://envisafe.ai" },
  { name: "SafeForm", slug: "safeform", href: "https://safeform.ai" },
];

const PARTNERS = ["Genetec: integration in development", "Axis TIPP member", "Procore: coming soon"];

function SuiteLinks() {
  return (
    <div>
      <div className="ws-label text-white mb-3">Suite</div>
      <ul className="text-sm text-[#A1A1AA] space-y-2" data-testid="footer-suite-links">
        {SUITE_LINKS.map((s) => (
          <li key={s.name}>
            <a
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`footer-suite-${s.slug}`}
              className="inline-flex items-center gap-2 hover:text-white"
            >
              <img
                src={`${BRAND_BASE}/${s.slug}/${s.slug}-32.png`}
                alt=""
                width="32"
                height="32"
                loading="lazy"
                className="w-8 h-8"
              />
              {s.name} ↗
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function SiteFooter() {
  return (
    <footer className="border-t-2 border-[#09090B] bg-[#09090B] text-white mt-24">
      <div className="max-w-7xl mx-auto px-6 py-10 grid sm:grid-cols-2 md:grid-cols-5 gap-8">
        <div>
          <img
            src="/brand/worksafestory-lockup-dark.svg"
            alt="WorkSafeStory"
            data-testid="footer-brand-lockup"
            className="h-8 w-auto"
          />
          <div className="ws-label text-[#FFCC00] mt-2">Why I Work Safe</div>
          <p className="text-sm text-[#A1A1AA] mt-3 max-w-xs leading-relaxed">
            Capturing the people, promises, and reasons behind every safe shift.
          </p>
        </div>
        <div>
          <div className="ws-label text-white mb-3">Program</div>
          <ul className="text-sm text-[#A1A1AA] space-y-2">
            <li>Submit a Story</li>
            <li>Earn a Safety Token</li>
            <li>Redeem at Company Store</li>
          </ul>
        </div>
        <SuiteLinks />
        <div>
          <div className="ws-label text-white mb-3">WorkSafeAgent LLC</div>
          <ul className="text-sm text-[#A1A1AA] space-y-2" data-testid="footer-contact-block">
            <li>Abilene, TX</li>
            <li>
              <a
                href="mailto:info@wsafeai.com"
                data-testid="footer-email-link"
                className="hover:text-white"
              >
                info@wsafeai.com
              </a>
            </li>
            <li>
              <a
                href="tel:+19402270017"
                data-testid="footer-phone-link"
                className="hover:text-white"
              >
                940.227.0017
              </a>
            </li>
            <li>
              <a
                href="https://worksafeagent.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-hub-link"
                className="hover:text-white"
              >
                worksafeagent.com ↗
              </a>
            </li>
          </ul>
        </div>
        <div>
          <div className="ws-label text-white mb-3">Compliance</div>
          <p className="text-xs text-[#A1A1AA] leading-relaxed">
            Submissions are reviewed by the safety team. Photos may appear on the Wall of Safety.
            Be respectful and inclusive. No PPE-bypass content.
          </p>
          <div className="mt-4 space-y-1 text-xs text-[#A1A1AA]" data-testid="footer-legal-block">
            <div>
              <span className="text-white font-semibold">Patent-pending</span> · USPTO
              provisional 63/992,261
            </div>
            <div>
              Zenodo DOI{" "}
              <a
                href="https://doi.org/10.5281/zenodo.20499515"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-zenodo-link"
                className="font-mono hover:text-white"
              >
                10.5281/zenodo.20499515
              </a>
            </div>
          </div>
        </div>
      </div>
      <div
        className="border-t border-[#27272A] max-w-7xl mx-auto px-6 py-4 flex flex-wrap gap-x-8 gap-y-2 text-xs text-[#A1A1AA]"
        data-testid="footer-partners"
      >
        <span className="ws-label text-[#FFCC00]">Partners</span>
        {PARTNERS.map((p) => <span key={p}>{p}</span>)}
      </div>
      <div className="border-t border-[#27272A] py-4 text-center text-xs tracking-[0.2em] uppercase text-[#52525B]">
        © {new Date().getFullYear()} WorkSafeAgent LLC · Abilene, TX · info@wsafeai.com · 940.227.0017 · Patent-pending · Zenodo DOI 10.5281/zenodo.20499515
      </div>
    </footer>
  );
}
